var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-form-popup",on:{"mouseover":function($event){_vm.showPopup = true},"mouseout":_vm.hidePopup}},[_vm._m(0),_c('span',{staticClass:"base-form-popuptext",class:{'show': _vm.showPopup}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"src":require("@/assets/img/orders/info-icon.svg")}})])
}]

export { render, staticRenderFns }